import {
  HRMonthly_Evaluation_Update,
  HRMonthly_EvaluationHead_POST,
  HRMonthly_EvaluationHead_Summary,
  HRMonthly_EvaluationDetail_GetRow,
  HRMonthly_EvaluationRating_List_GetRow,
} from "../../Server/ApiV2";
// HR Monthly Evaluation Update
export const onGetHRMonthly_Evaluation_Update = async (postData) => {
  try {
    const response = await HRMonthly_Evaluation_Update(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

// HR Monthly Evaluation Head POST
export const onGetHRMonthly_EvaluationHead_POST = async (postData) => {
  try {
    const response = await HRMonthly_EvaluationHead_POST(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetHRMonthly_EvaluationDetail_GetRow = async (postData) => {
  try {
    const response = await HRMonthly_EvaluationDetail_GetRow(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

// HR Monthly Evaluation Head Summary
export const onGetHRMonthly_EvaluationHead_Summary = async (postData) => {
  try {
    const response = await HRMonthly_EvaluationHead_Summary(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

export const onGetHRMonthly_EvaluationRating_List_GetRow = async (postData) => {
  try {
    const response = await HRMonthly_EvaluationRating_List_GetRow(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
